'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = {
  skeleton: function () {
    function skeleton() {
      return {
        '@keyframes skeleton': {
          '0%': {
            backgroundPosition: '-100vw 0vw'
          },
          '100%': {
            backgroundPosition: '100vw 0vw'
          }
        }
      };
    }

    return skeleton;
  }()
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/@catalytic/pushbot-ui/styles/animations.js
// module id = 1327
// module chunks = 32